const resource = '/admin/v1/applications';

export default $axios => ({
  index(payload) {
    return $axios.get(`${resource}`, {params: payload});
  },

  show(id) {
    return $axios.get(`${resource}/${id}`);
  },

  create(payload) {
    return $axios.post(`${resource}`, payload);
  },

  createWord(payload) {
    return $axios.post(`${resource}/create-word`, payload);
  },

  createNewAppFile({ id: appId, type }) {
    return $axios.post(`${resource}/${appId}/files`, { type });
  },

  createNewAppPdfFile({ id: appId, payload }) {
    return $axios.post(`${resource}/${appId}/files-pdf`, payload, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },

  cloneAppFile({ fileId }) {
    return $axios.post(`${resource}/clone-file/${fileId}`);
  },

  updateWordConfigFile({id, config, fileId}) {
    return $axios.put(`${resource}/${id}/files`, { config, fileId });
  },

  uploadWordTemplate(payload) {
    return $axios.post(`${resource}/upload-word-template`, payload, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },

  uploadTempPdfFile(payload) {
    return $axios.post(`${resource}/upload-temp-pdf`, payload, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },

  sortFile(payload) {
    return $axios.post(`${resource}/sort-file`, payload);
  },

  update(id, payload) {
    return $axios.put(`${resource}/${id}`, payload);
  },

  testDownload({fileId, payload}) {
    return $axios.post(`${resource}/test-download/${fileId}`, {
      payload
    })
  },

  delete(id) {
    return $axios.delete(`${resource}/${id}`);
  },

  createField(payload) {
    return $axios.post(`${resource}/fields`, payload);
  },

  createRule(appId, payload) {
    return $axios.post(`${resource}/${appId}/rule`, payload);
  },

  updateField(id, payload) {
    return $axios.put(`${resource}/fields/${id}`, payload);
  },

  createInstanceField(payload) {
    return $axios.post(`${resource}/file-fields`, payload);
  },

  updateInstanceField(id, payload) {
    return $axios.put(`${resource}/file-fields/${id}`, payload);
  },

  deleteFieldInstance(id) {
    return $axios.delete(`${resource}/file-fields/${id}`);
  },

  createQuestion(payload) {
    return $axios.post(`${resource}/questions`, payload);
  },

  updateQuestion(id, payload) {
    return $axios.put(`${resource}/questions/${id}`, payload);
  },

  deleteQuestion(id) {
    return $axios.delete(`${resource}/questions/${id}`);
  },

  sortQuestion(payload) {
    return $axios.put(`${resource}/questions/sort`, payload);
  },

  refreshQuestion(payload) {
    return $axios.get(`${resource}/questions/get-questions`, {params: {ids: payload}});
  },

  createSurveyQuestionField(payload) {
    return $axios.post(`${resource}/survey-question-fields`, payload);
  },

  updateSurveyQuestionField(id, formData) {
    return $axios.post(`${resource}/survey-question-fields/update/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },

  deleteSurveyQuestionField(surveyQuestionFieldId) {
    return $axios.delete(`${resource}/survey-question-fields/${surveyQuestionFieldId}`);
  },

  sortSurveyQuestionField(payload) {
    return $axios.put(`${resource}/survey-question-fields/sort`, payload);
  },

  createFieldGroup(payload) {
    return $axios.post(`${resource}/field-groups`, payload);
  },

  updateFieldGroup(id, payload) {
    return $axios.patch(`${resource}/field-groups/${id}`, payload);
  },

  updateOptions(questionId, payload) {
    return $axios.patch(`${resource}/questions/update-options/${questionId}`, {
      options: payload
    });
  },

  deleteFieldGroup(fieldGroupId) {
    return $axios.delete(`${resource}/field-groups/${fieldGroupId}`);
  },

  sortFieldGroup(payload) {
    return $axios.put(`${resource}/field-groups/sort`, payload);
  },

  sortField(payload) {
    return $axios.put(`${resource}/file-fields/sort`, payload);
  },

  saveMultipleInstances(payload) {
    return $axios.patch(`${resource}/file-fields/save-many`, payload);
  },

  updateFieldPlaceholder(payload) {
    return $axios.put(`${resource}/file-fields/update-placeholder`, payload);
  },

  updatePublish({ id, publish, companies }) {
    return $axios.put(`${resource}/${id}/update-publish`, {publish, companies})
  },

  downloadPdf(payload) {
    return $axios.post(`${resource}/download-pdf`, payload);
  },

  saveNewVersion(id) {
    return $axios.post(`${resource}/${id}/save-new-version`,);
  },

  saveNewPdfFile(payload) {
    return $axios.put(`${resource}/save-new-pdf`, payload);
  },

  getAll() {
    return $axios.get(`${resource}/all`);
  },

  createByApplication({ id: appId, payload }) {
    return $axios.post(`${resource}/${appId}/create-by-app`, payload);
  },

  cloneApplication(id) {
    return $axios.post(`${resource}/clone-application/${id}`);
  },

  getListApplicationUser(payload) {
    return $axios.get(`${resource}/list-app-user`, {params: payload});
  },

  getFilterProjectList(payload = {}) {
    return $axios.get(`${resource}/list-app-user/get-filter`, {params: payload});
  },

  getApplicationQuantity() {
    return $axios.get(`${resource}/quantity-app-user`);
  },

  getListFilterTransaction() {
    return $axios.get(`${resource}/list-filter-transaction`);
  },

  exportApplicationUser(payload) {
    return $axios.post(`/admin/v1/export-application-user`, payload);
  },

  getApplicationUserSteps() {
    return $axios.get(`${resource}/application-user-step`);
  },

  getListAppDefault() {
    return $axios.get(`${resource}/list-application-default`);
  },

  updateListApp(payload) {
    return $axios.post(`${resource}/list-application-default`, payload);
  },

  listTransferRequest() {
    return $axios.get(`/admin/v1/transfer-request`)
  },

  confirmTransferRequest(id) {
    return $axios.post(`/admin/v1/transfer-request/${id}`, )
  },

  getCampaignEmailTemplates() {
    return $axios.get(`${resource}/campaigns/email-templates`);
  },

  getAppCampaignsWithFilter(payload) {
    return $axios.get(`${resource}/campaigns/filter`, {params: payload});
  },
  getFilterAttributeForAppCampaign() {
    return $axios.get(`${resource}/campaigns/get-filter-attributes`);
  }
});
